import { IframeWrapper } from "@/common/styles/page.css"
import { NEXT_PUBLIC_OPERATION_REGULATION_EN_URL } from "@/common/constants"

const ContentEN = () => {
    return (
        <>
            <IframeWrapper
                src={`${NEXT_PUBLIC_OPERATION_REGULATION_EN_URL}#toolbar=0&navpanes=0&scrollbar=0`}
                style={{
                    height: '90vh'
                }}
            />
        </>
    )
}

export default ContentEN
